import React, { FC, ReactElement } from 'react'
import Alert from '@material-ui/lab/Alert'

type Props = {
    type?: 'info' | 'warning' | 'error'
    message: string
}

export const StatusMessage: FC<Props> = ({ type = 'error', message }: Props): ReactElement => (
    <Alert className='status-message' severity={type} variant='filled'>
        <span className={`status-message-${type}`}>{message}</span>
    </Alert>
)
